import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Grid } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import ButtonBase from '../../components/UI/Buttons/ButtonBase';

import Aux from '../../hoc/NoParent';
import Spinner from '../../components/UI/Spinner';
import AjaxErrorMessage from '../../components/UI/AjaxErrorMessage';
import HomeAction from '../../components/Home/HomeAction';

import { getLandingPageSummary } from '../../store/actions';

import DataFormatter from '../../util/dataFormatter';

const styles = (theme) => {
    return {
        main: {
            padding: theme.spacing(2)
        }
    };
}

const _createSettlementAction = settlement => {
    return {
        title: 'Last Settlement', 
        linkTo: `/settlement/${settlement.check_id}`, 
        content: <table>
            <tbody>
                <tr><td>Date</td><td>{DataFormatter.toDate(settlement.check_date)}</td></tr>
                <tr><td>Check #</td><td>{settlement.check_number}</td></tr>
                <tr><td>Amount</td><td>{DataFormatter.toMoney(settlement.check_amount)}</td></tr>
                <tr><td>&nbsp;</td><td>&nbsp;</td></tr>
            </tbody>
        </table>
    }
};

const _createHosAction = hosInformation => {
    return {
        title: 'Current HOS', 
        linkTo: '/logs', 
        content: <table>
            <tbody>
                <tr><td>Drive Time (hrs)</td><td>{DataFormatter.toNumber(hosInformation.DriveHours || 0, 2)}</td></tr>
                <tr><td>On Duty Time (hrs)</td><td>{DataFormatter.toNumber(hosInformation.OnDutyHours || 0, 2)}</td></tr>
                <tr><td>Week Clock (hrs)</td><td>{DataFormatter.toNumber(hosInformation.WeekHours || 0, 2)}</td></tr>
                <tr><td>Hours Gained At Midnight</td><td>{DataFormatter.toNumber(hosInformation.HoursGainedAtMidnight || 0, 2)}</td></tr>
            </tbody>
    </table>
    }
}

const Home = props => {
    const { loading, token, error, landingPageSummary, loadLandingPageData } = props;

    useEffect(() => {
        if(loading === false && token && landingPageSummary == null) {
            loadLandingPageData(token);
        }
    }, [loading, token, landingPageSummary]);

    if(loading) return <Spinner />;

    const homeActions = [];
    
    const quickLinks = [
        { title: 'Settlements', linkTo: '/settlement' }, 
        { title: 'Logs', linkTo: '/logs' }, 
        { title: 'Loads', linkTo: '/loads' }, 
        { title: 'Help', linkTo: '/faq' }
    ];

    if(!loading && landingPageSummary !== null) {
        const hosInformation = landingPageSummary.current_hos.length > 0 ? landingPageSummary.current_hos[0] : {};

        homeActions.push(_createHosAction(hosInformation));

        homeActions.push(_createSettlementAction(landingPageSummary.settlement));
    }

    return (
        <Aux>
            <div className={props.classes.main}>
                <Grid container spacing={2}>
                    {
                        homeActions.map(action => {
                            return (
                                <Grid item key={action.title} xs={12} sm={6} lg={4} xl={3}>
                                    <HomeAction {...action} />
                                </Grid>
                            );
                        })
                    }
                    <Grid item xs={12} sm={6} lg={4} xl={3} align="center" height='100%'>
                        <HomeAction title="Quick Links">
                            {
                                quickLinks.map(quickLink => {
                                    return (
                                        <ButtonBase key={quickLink.title} onClick={() => props.history.push(quickLink.linkTo)}>{quickLink.title}</ButtonBase>
                                    );
                                })
                            }
                            <p>&nbsp;</p>
                        </HomeAction>
                    </Grid>
                </Grid>
            </div>
            { error ? <AjaxErrorMessage error={error} /> : null }
        </Aux>
    );
}

const mapStateToProps = (state) => {
    return {
        loading: state.home.loading, 
        error: state.home.error, 
        token: state.auth.token, 
        landingPageSummary: state.home.landingPageSummary
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        loadLandingPageData: (token) => dispatch(getLandingPageSummary(token))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Home));